export default __webpack_public_path__ + "static/office-christmas-party-f9fb900ee00a7ba5def037c8ed45a30c.jpg";